import { render } from "./StepContent.vue?vue&type=template&id=773178a6&scoped=true"
import script from "./StepContent.vue?vue&type=script&lang=js"
export * from "./StepContent.vue?vue&type=script&lang=js"

import "./StepContent.vue?vue&type=style&index=0&id=773178a6&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-773178a6"]])

export default __exports__